// Time and age formatting for a US-first app (12-hour clock, lower-case am/pm as in the CI comp).
export const MIN = 60_000;
export const H = 60 * MIN;

export function clock(t: number | string | Date, tz?: string): string {
  const s = new Date(t).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: tz });
  return s.replace(' AM', ' am').replace(' PM', ' pm');
}

/** "45 min", "1 h 20", "2 h" */
export function duration(ms: number): string {
  const m = Math.max(0, Math.round(ms / MIN));
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  return r ? `${h} h ${String(r).padStart(2, '0')}` : `${h} h`;
}

type AgeLike = { months: number; weeks: number; useCorrected: boolean; correctedMonths: number; correctedWeeks: number };

export function ageLabel(age: AgeLike): string {
  const w = Math.floor(age.useCorrected ? age.correctedWeeks : age.weeks);
  const m = Math.floor(age.useCorrected ? age.correctedMonths : age.months);
  if (w < 9) return `${Math.max(0, w)} ${w === 1 ? 'week' : 'weeks'}`;
  if (m < 24) return `${m} ${m === 1 ? 'month' : 'months'}`;
  const y = Math.floor(m / 12);
  return `${y} ${y === 1 ? 'year' : 'years'}`;
}

export const uuid = () => crypto.randomUUID();
